import { render, staticRenderFns } from "./homeFooter.vue?vue&type=template&id=39fd7aa6"
import script from "./homeFooter.vue?vue&type=script&lang=js"
export * from "./homeFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports